export const DEFAULT_POSTPONEMENT_BANNER_HEADER_EN =
  'Automatic enrollment, or option to opt-in today';

export const DEFAULT_POSTPONEMENT_BANNER_BODY_EN =
  "You'll be automatically enrolled on {date}, unless you cancel. If you prefer, you can enroll sooner by clicking 'Opt in' in below.";
